import React from 'react'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { OrContainer, OrSeperator } from './OrBlock.styled'
import { css } from '@emotion/css'
import { useMediaQuery, useTheme } from '@mui/material'

export const OrBlock = () => {
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('laptop'))
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile_s'))

  return (
    <div className={css(OrContainer, isTablet && `height: 60px;`, isMobile && `width: 90%;`)}>
      <div className={css(OrSeperator, `background-color: ${theme.palette.custom.grey2}`)} />
      <HelperWrapper t="or-text-label" />
      <div className={css(OrSeperator, `background-color: ${theme.palette.custom.grey2}`)} />
    </div>
  )
}
